export default "__VITE_ASSET__90154d2a__"